<template>
  <div>
    <main>
      <pageTabs
        :value="activeTab.ClientInfoRuleId"
        :items="tabItems"
        @closeTab="confirmCloseTab"
        @change="setActiveTab"
        class="page-tabs"
        :class="
          (navPanelTransitioning || rightPanelTransitioning) &&
          'transition-width'
        "
        :style="`width: calc(100vw - ${panelWidth}px)`"
      >
        <clientManagement
          v-show="activeTab.ClientInfoRuleId === 'clientManagement'"
        />
        <client
          v-show="activeTab.ClientInfoRuleId !== 'clientManagement'"
          :id="activeTab.ClientInfoRuleId"
          :summary="summary[activeTab.ClientInfoRuleId] || {}"
          @showChangeSummary="showChangeSummary"
          @hideChangeSummary="hideChangeSummary"
          @setSummaryTitle="setSummaryTitle"
          @setSummaryDetails="setSummaryDetails"
          @setIsSummaryFormValid="setIsSummaryFormValid"
        />
      </pageTabs>
    </main>
    <unsavedChangesModal
      :value="showCloseConfirmation"
      @closeModal="cancelConfirmation"
      @confirmLeave="closeTab"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import pageTabs from "@/qux-common/qux22/components/molecules/page-tabs";

import client from "@/components/client";
import clientManagement from "@/components/clientManagement";
import unsavedChangesModal from "@/components/unsaved-changes-modal";

export default {
  components: {
    client,
    clientManagement,
    pageTabs,
    unsavedChangesModal,
  },
  data() {
    return {
      showCloseConfirmation: false,
      tabToClose: undefined,
      summary: {},
    };
  },
  methods: {
    setActiveTab(tab) {
      this.$store.dispatch("setActiveTab", tab);
    },
    confirmCloseTab(tabItem) {
      const tabId = tabItem.id;
      this.tabToClose = tabId;
      if (this.hasUpdatedConfigValues[tabId]) {
        this.showCloseConfirmation = true;
      } else {
        this.closeTab();
      }
    },
    closeTab() {
      this.hideChangeSummary();
      this.$store.dispatch("closeTab", { ClientInfoRuleId: this.tabToClose });
      this.tabToClose = undefined;
      this.showCloseConfirmation = false;
    },
    cancelConfirmation() {
      this.tabToClose = undefined;
      this.showCloseConfirmation = false;
    },
    showChangeSummary() {
      this.summary = {
        ...this.summary,
        [this.activeTab.ClientInfoRuleId]: {
          ...this.summary[this.activeTab.ClientInfoRuleId],
          show: true,
        },
      };
    },
    hideChangeSummary() {
      this.summary = {
        ...this.summary,
        [this.activeTab.ClientInfoRuleId]: { show: false },
      };
    },
    setSummaryTitle(title) {
      this.summary = {
        ...this.summary,
        [this.activeTab.ClientInfoRuleId]: {
          ...this.summary[this.activeTab.ClientInfoRuleId],
          title,
        },
      };
    },
    setSummaryDetails(details) {
      this.summary = {
        ...this.summary,
        [this.activeTab.ClientInfoRuleId]: {
          ...this.summary[this.activeTab.ClientInfoRuleId],
          details,
        },
      };
    },
    setIsSummaryFormValid(isFormValid) {
      this.summary = {
        ...this.summary,
        [this.activeTab.ClientInfoRuleId]: {
          ...this.summary[this.activeTab.ClientInfoRuleId],
          isFormValid,
        },
      };
    },
  },
  computed: {
    tabItems() {
      const openTabs = this.openTabs.map(
        ({ name, ClientInfoRuleId, isLoading }) => {
          const tabHasUpdatedConfigValues =
            this.hasUpdatedConfigValues[ClientInfoRuleId];
          return {
            name: name,
            href: `#${ClientInfoRuleId}`,
            id: ClientInfoRuleId,
            isLoading,
            leftIcon: tabHasUpdatedConfigValues && "mdi-alert-outline",
            leftIconTooltip:
              tabHasUpdatedConfigValues && "There are unsaved changes",
          };
        }
      );
      return [
        {
          name: "Client Management",
          href: "#clientManagement",
          hideCloseButton: true,
        },
        ...openTabs,
      ];
    },
    ...mapGetters({
      openTabs: "getTabs",
      activeTab: "getActiveTab",
      hasUpdatedConfigValues: "hasUpdatedConfigValues",
      panelWidth: "getTotalPanelWidth",
      navPanelTransitioning: "getNavPanelTransitioning",
      rightPanelTransitioning: "getRightPanelTransitioning",
    }),
  },
};
</script>

<style lang="scss" scoped>
.page-tabs {
  box-shadow: unset;
  height: calc(100vh - $header-height);
  &.transition-width {
    transition: width 200ms;
  }
  &::v-deep {
    .v-tabs-items {
      height: calc(100% - $page-tab-height);
    }
    .v-tabs-bar {
      z-index: 10;
      .v-tab,
      .v-tab:not(.v-tab--active) {
        .left-icon {
          color: $qvo-color-yellow-100;
        }
      }
    }
  }
}
</style>